import { Travel } from "../../common/models/Travel";
import { TravelResponse } from "../models/responses/TravelResponse";

export const TravelMapper = (data: TravelResponse): Travel => {
  return {
    id: data._id,
    client: data.client,
    originAddress: data.originAddress,
    destinationAddress: data.destinationAddress,
    latitudeOrigin: data.latitudeOrigin,
    longitudeOrigin: data.longitudeOrigin,
    longitudeDestination: data.longitudeDestination,
    latitudeDestination: data.latitudeDestination,
    status: data.status,
    vehicleType: {
      ...data.type_vehicle_dto,
      id: data.type_vehicle
    },
    driver: data.driver && data.driverClient && data.vehicle? {
      licenses: data.driver.licences,
      vehicle: data.vehicle,
      birthday: data.driver.birthday,
      ci: data.driver.ci,
      photo: data.driver.photo,
      user: data.driverClient,
    }: undefined,
    identification: data.identification,
    route: data.route,
    createdAt: data.createdAt,
    updatedAt: data.updatedAt
  }
}